/**
 * <low-power-video> — plays a muted background <video> on first user interaction.
 * iOS Low Power Mode blocks muted autoplay, leaving a frozen poster; this resumes
 * playback on the first touch/click. Adapted from 10x-health-network-theme.
 *
 * Wraps a hero containing exactly one <video>. No-op with no video.
 */
export default function initLowPowerVideo() {
  if (customElements.get('low-power-video')) return;

  customElements.define(
    'low-power-video',
    class LowPowerVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this._onInteract = () => {
          if (this.video.paused) {
            const played = this.video.play();
            if (played && typeof played.catch === 'function') {
              played.catch((error) => {
                console.warn('[low-power-video] play() blocked:', error);
              });
            }
          }
        };

        this.addEventListener('touchstart', this._onInteract, { once: true, passive: true });
        this.addEventListener('click', this._onInteract, { once: true });
      }

      disconnectedCallback() {
        if (!this._onInteract) return;
        this.removeEventListener('touchstart', this._onInteract);
        this.removeEventListener('click', this._onInteract);
      }
    },
  );
}
